import React from 'react';

import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { ResizableTextarea } from '@r1-frontend/ui-react/experimental/forms';

import * as S from './styled';

const defaultPlaceholder = 'Комментарий для инженера';

type TCommentProps = {
    defaultValue?: string,
    handleInputComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
    placeholder?: string,
}

const Comment = ({ defaultValue, handleInputComment, placeholder = defaultPlaceholder }: TCommentProps): JSX.Element=> {
    return (
        <S.Block>
            <WithSkeleton width={'100%'} height={48}>
                <ResizableTextarea
                    defaultValue={defaultValue}
                    onChange={handleInputComment}
                    placeholder={placeholder}
                />
            </WithSkeleton>
        </S.Block>
    );
};

export default Comment;
